import { combineReducers } from "redux";
import { reducerMode } from "./stateMode";
import { getListEnum, getListReducer } from "./stateListUtils";

export const FetchStateCountries = getListEnum('COUNTRIES');
export const FetchStateOwners = getListEnum('OWNERS');
export const FetchStateReusables = getListEnum('REUSABLES');
export const FetchStateServices = getListEnum('SERVICES');
export const FetchStatePageCategories = getListEnum('PAGE_CATEGORIES');

const rootPageReducer = combineReducers({
	pageOwners: getListReducer(FetchStateOwners),
	countries: getListReducer(FetchStateCountries),
	pageReusable: getListReducer(FetchStateReusables),
	pageServices: getListReducer(FetchStateServices),
	pageCategories: getListReducer(FetchStatePageCategories),
	mode: reducerMode,
});

export default rootPageReducer;
